/* Qbedding: match every entered word in the title. Load before theme.js. */
(function () {
  'use strict';
  if (window.QBStrictSearch) return;
  var script = document.currentScript;
  var searchURL = new URL(script.dataset.searchUrl, window.location.origin);
  var generatedPattern = /^title:"[^"\\]+"(?: AND title:"[^"\\]+")*$/u;

  function toPlain(value) {
    var text = String(value || '').trim();
    if (!generatedPattern.test(text)) return text;
    return Array.from(text.matchAll(/title:"([^"\\]+)"/gu), function (match) {
      return match[1];
    }).join(' ');
  }

  function toQuery(value) {
    var text = String(value || '').trim();
    if (generatedPattern.test(text)) return text;
    var words = text.match(/[\p{L}\p{N}]+(?:['’\-][\p{L}\p{N}]+)*/gu) || [];
    if (!words.length) return text;
    return words.map(function (word) {
      return 'title:"' + word + '"';
    }).join(' AND ');
  }

  function isSearchURL(url) {
    return url.origin === window.location.origin &&
      url.pathname.replace(/\/$/, '') === searchURL.pathname.replace(/\/$/, '');
  }

  window.QBStrictSearch = { toQuery: toQuery, toPlain: toPlain };

  // Includes direct search URLs and ordinary search links, not just forms.
  var current = new URL(window.location.href);
  if (isSearchURL(current) && current.searchParams.get('q')) {
    var query = current.searchParams.get('q');
    var strictQuery = toQuery(query);
    if (strictQuery !== query || current.searchParams.has('options[prefix]')) {
      current.searchParams.set('q', strictQuery);
      current.searchParams.delete('options[prefix]');
      window.location.replace(current.href);
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var destination = new URL(form.action, window.location.href);
    if (!isSearchURL(destination) || form.method.toLowerCase() !== 'get') return;
    if (!input.value.trim() || !form.checkValidity()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var data = new FormData(form);
    destination.search = '';
    data.forEach(function (value, key) {
      if (typeof value === 'string') destination.searchParams.append(key, value);
    });
    destination.searchParams.set('q', toQuery(input.value));
    destination.searchParams.delete('options[prefix]');
    destination.searchParams.delete('page');
    window.location.assign(destination.href);
  }, true);

  function restoreReadableInputs() {
    document.querySelectorAll('form input[name="q"]').forEach(function (input) {
      var form = input.closest('form');
      if (form && isSearchURL(new URL(form.action, window.location.href))) {
        input.value = toPlain(input.value);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreReadableInputs);
  } else {
    restoreReadableInputs();
  }
  document.addEventListener('shopify:section:load', restoreReadableInputs);
})();
